export default __webpack_public_path__ + "static/manage-overtime-584bfbe848d333aa82bc5efaee28f82d.png";